import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import * as h2Api from '../h2Api'
import { ACCOUNT_REQUEST } from '../actions/educatorAccountRequestActions'

const initialState = {}
const initialNoteForm = {
  fistName: '',
  lastName: '',
  email: '',
  school: null,
  specifiedUsersRequired: 50
}
const data = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}

export default combineReducers({
  data,
  requestDetail: h2Api.restReducer(ACCOUNT_REQUEST),
  educatorAccountRequestForm: modelReducer(
    'educatorAccountRequest.educatorAccountRequestForm',
    initialNoteForm
  ),
  forms: formReducer('educatorAccountRequest', {
    educatorAccountRequestForm: initialNoteForm
  })
})
